import { IconNode } from "@tabler/icons-react";
import * as svgson from "svgson";

export function svgToIconNode(svgRaw: string): IconNode {
    return svgson.parseSync(svgRaw).children.map(({ name, attributes }, i) => {
        attributes.key = `svg-${i}`;
        attributes.strokeWidth = attributes["stroke-width"];
        delete attributes["stroke-width"];
        return [name, attributes];
    }) as IconNode;
}
